import { observer } from 'mobx-react-lite';
import OptionsFullWithLoadedCategoriesContent from './OptionsFullWithLoadedCategoriesContent';
import OptionsFullWithPendingCategoriesContent from './OptionsFullWithPendingCategoriesContent';
import { AnimationClassNames } from '@uifabric/styling';
import { OwaModal } from 'owa-dialog';
import { hideFullOptions } from 'owa-options-core';
import { getCurrentSubcategory, getStore } from 'owa-options-store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);

const OptionsFull = observer(function OptionsFull(props: {}) {
    const hide = () => {
        let selectedSubCategory = getCurrentSubcategory();
        hideFullOptions(false, selectedSubCategory.key);
    };
    const { isFullOptionsShown, areAllAllowedSubCategoriesLoaded } = getStore();
    if (!isFullOptionsShown) {
        return null;
    }
    return (
        <OwaModal
            isOpen={isFullOptionsShown}
            onDismiss={hide}
            allowTouchBodyScroll={true}
            containerClassName={className(
                isFullOptionsShown
                    ? AnimationClassNames.slideUpIn20
                    : AnimationClassNames.slideDownOut20,
                styles.modal
            )}>
            <div className={styles.container}>
                {areAllAllowedSubCategoriesLoaded ? (
                    <OptionsFullWithLoadedCategoriesContent />
                ) : (
                    <OptionsFullWithPendingCategoriesContent />
                )}
            </div>
        </OwaModal>
    );
});
export default OptionsFull;

let optionsFullContainer: HTMLDivElement;

export function mountOptionsFullPopup() {
    if (!optionsFullContainer) {
        optionsFullContainer = document.createElement('div');
        document.body.appendChild(optionsFullContainer);

        ReactDOM.render(
            <React.StrictMode>
                <OptionsFull />
            </React.StrictMode>,
            optionsFullContainer
        );
    }
}
